import overrideIfMinBetNumberEnabled from "./MinBetNumberRegistrator";
overrideIfMinBetNumberEnabled(function () {
    (function (baseSlipSelection) {
        if (!baseSlipSelection) {
            return;
        }
        var _serialize = baseSlipSelection.prototype.serialize, _processBetUpdate = baseSlipSelection.prototype.processBetUpdate, _deserializeSelection = baseSlipSelection.deserializeSelection;
        $.extend(baseSlipSelection.prototype, {
            serialize() {
                return $.extend(_serialize.call(this), { MinBetNumber: this.MinBetNumber });
            },
            processBetUpdate(updates) {
                _processBetUpdate.call(this, updates);
                if (updates === -1) {
                    return;
                }
                //if we got diff value for mbn => we should trigger update
                var triggerViewUpdate = this.MinBetNumber && this.MinBetNumber !== updates.MinBetNumber;
                this.MinBetNumber = updates.MinBetNumber;
                if (triggerViewUpdate) {
                    BetSlip.CurrentMode.updateView();
                }
            }
        });
        $.extend(baseSlipSelection, {
            deserializeSelection(data) {
                var sel = _deserializeSelection.call(this, data);
                return sel ? $.extend(sel, { MinBetNumber: data.MinBetNumber }) : sel;
            }
        });
    })(window.BaseSlipSelection);
});
//# sourceMappingURL=BaseSelection.js.map